import React from 'react'

export default (props) =>
  <svg {...props} width='11' height='6' viewBox='0 0 11 6' fill='none'>
    <path d='M10 5L5.5 1L1 5' stroke='white' strokeLinecap='round' strokeLinejoin='round' />
  </svg>
